import { Card, Space } from "antd";
import SummaryCard from "../../../home/Welcome/SummaryCard";
import CollapsibleCardList from "../../../../components/CollapsibleCardList";
import { useSelector } from "react-redux";
import moment from "moment";

const Summary = () => {
    const { app: { user } } = useSelector((state: any) => ({
        app: state.app
    }));

    const data = [
        {
            header: "Primary Details",
            fields: [
                { label: "First Name", value: user?.firstName },
                { label: "Last Name", value: user?.lastName },
                { label: "Designation", value: user?.role?.name },
                { label: "Date of Birth", value: moment(user?.dob).format("DD MMM YYYY") },
                { label: "Marital Status", value: user?.maritalStatus ?? "-" },
                { label: "Blood Group", value: user?.bloodGroup ?? '-' },
                { label: "Gender", value: user?.gender },
                { label: "Physically Handicapped", value: user?.isPhysicallyHandicapped ?? '-' },
            ],
        },
    ];

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <SummaryCard />
            <CollapsibleCardList data={data} />
        </Space>
    );
}

export default Summary;